import { QueryFactory } from "../../../../Common";
export const QReportsMetaData = QueryFactory("ReportsMetaData");
//# sourceMappingURL=QReportsMetaData.js.map